import {
  CANCEL_APPOINTMENT_SUPERADMIN,
  CANCEL_APPOINTMENT_SUPERADMIN_FAILURE,
  CANCEL_APPOINTMENT_SUPERADMIN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const cancelAppointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_APPOINTMENT_SUPERADMIN:
      return { ...state, loading: true };
    case CANCEL_APPOINTMENT_SUPERADMIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case CANCEL_APPOINTMENT_SUPERADMIN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default cancelAppointmentReducer;
